/* Fetch only the hovered card's alternate image. Delegation covers AJAX grids. */
(() => {
  if (window.ssApparelHoverInstalled) return;
  window.ssApparelHoverInstalled = true;
  const header = document.querySelector('.v2-header');
  const syncToolbarOffset = () => {
    const position = header && getComputedStyle(header).position;
    const offset = position === 'sticky' || position === 'fixed' ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--ss-apparel-toolbar-top', `${offset}px`);
  };
  syncToolbarOffset();
  if (header) new ResizeObserver(syncToolbarOffset).observe(header);
  window.addEventListener('resize', syncToolbarOffset, { passive: true });
  const desktop = matchMedia('(hover: hover) and (pointer: fine)');
  const reveal = event => {
    if (!desktop.matches) return;
    const photo = event.target.closest?.('.apparel-soft-card .v2-product-photo');
    const image = photo?.querySelector('[data-ss-hover-src]');
    if (!image || image.dataset.ssHoverLoaded) return;
    image.dataset.ssHoverLoaded = 'true';
    image.addEventListener('load', () => photo.classList.add('ss-hover-ready'), { once: true });
    image.srcset = image.dataset.ssHoverSrcset;
    image.src = image.dataset.ssHoverSrc;
  };
  document.addEventListener('pointerover', reveal);
  document.addEventListener('focusin', reveal);
  const formatReviews = (root = document) => {
    root.querySelectorAll('.ss-apparel-grid-item .jdgm-prev-badge').forEach(badge => {
      const average = Number(badge.dataset.averageRating);
      const count = Number(badge.dataset.numberOfReviews);
      const text = badge.querySelector('.jdgm-prev-badge__text');
      if (!text || !Number.isFinite(average) || count <= 0) return;
      const summary = `${average.toFixed(1)} (${count})`;
      if (text.textContent !== summary) text.textContent = summary;
      badge.setAttribute('aria-label', `Rated ${average.toFixed(1)} out of 5 from ${count} reviews`);
    });
  };
  formatReviews();
  const grid = document.getElementById('CollectionAjaxResult');
  if (grid) {
    let pending = false;
    new MutationObserver(records => {
      if (pending || !records.some(record => record.addedNodes.length)) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; formatReviews(grid); });
    }).observe(grid, { childList: true, subtree: true });
  }
  window.addEventListener('popstate', () => { if (document.querySelector('[data-ss-apparel-categories]')) location.reload(); });
  const categoryCache = new Map();
  const categoryUrl = link => {
    const url = new URL(link.href);
    const current = new URL(location.href);
    for (const key of ['sort_by', 'preview_theme_id', 'pb']) {
      if (current.searchParams.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    return url;
  };
  const loadCategory = (url, section) => {
    const fetchUrl = new URL(url);
    fetchUrl.searchParams.set('section_id', section.dataset.sectionId);
    const key = fetchUrl.href;
    if (!categoryCache.has(key)) {
      const result = fetch(fetchUrl).then(async response => {
        if (!response.ok) throw new Error('Collection request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.getElementById('CollectionAjaxContent');
        if (!replacement) throw new Error('Collection content missing');
        return replacement.innerHTML;
      }).catch(error => { categoryCache.delete(key); throw error; });
      categoryCache.set(key, result);
    }
    return categoryCache.get(key);
  };
  const prepareCategory = event => {
    if (event.type === 'pointerover' && !desktop.matches) return;
    const link = event.target.closest?.('[data-ss-apparel-categories] a');
    const section = document.getElementById('CollectionAjaxResult');
    if (link && section && !link.classList.contains('active')) loadCategory(categoryUrl(link), section).catch(() => {});
  };
  document.addEventListener('pointerover', prepareCategory);
  document.addEventListener('focusin', prepareCategory);
  const currentFilterPresent = () => Array.from(new URL(location.href).searchParams.keys()).some(key => key.startsWith('filter.'));
  let categoryRequest;
  document.addEventListener('click', async event => {
    const link = event.target.closest?.('[data-ss-apparel-categories] a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const content = document.getElementById('CollectionAjaxContent');
    const section = document.getElementById('CollectionAjaxResult');
    if (!content || !section) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = categoryUrl(link);
    if (url.pathname === location.pathname && url.search === location.search) return;
    categoryRequest?.abort();
    categoryRequest = new AbortController();
    const request = categoryRequest;
    const status = content.querySelector('.ss-apparel-category-status');
    if (status) status.textContent = 'Updating products...';
    content.setAttribute('aria-busy', 'true');
    try {
      const markup = await loadCategory(url, section);
      if (request.signal.aborted) return;
      content.innerHTML = markup;
      history.pushState({}, '', url);
      window.theme?.sections?.reinit('collection-template');
      window.theme?.collapsibles?.init(content);
      document.dispatchEvent(new CustomEvent('collection:reloaded'));
      formatReviews(content);
      const active = content.querySelector('[data-ss-apparel-categories] a.active');
      active?.setAttribute('aria-current', 'true');
      active?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError' && status) status.textContent = 'Could not update products. Please try again.';
    } finally {
      if (categoryRequest === request) content.removeAttribute('aria-busy');
    }
  }, true);
})();
